import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(protected)/settings/skopa/")({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/(protected)/settings/skopa/"!</div>
}
